import { SET_DRIVERS, UPDATE_CASH } from '../actions/types/index';

export default (state = [], action) => {
  switch (action.type) {
    case SET_DRIVERS:
      return action.payload;
    case UPDATE_CASH:
      const updateDrivers = { ...state };
      updateDrivers[action.payload.position].cash = action.payload.espece;
      return { ...updateDrivers };
    default:
      return state;
  }
};
